export class BaseBulkRequestDto<T> {
  constructor(records: Array<T>) {
    this.bulk = records;
  }
  bulk: T[];
}
